.tabList::before {
  display: none;
}

.tab,
.tab[data-active] {
  background-color: transparent !important;
  border-bottom: 2px solid transparent;
  padding: 8px 14px;
}

.tab[data-active] {
  border-bottom-color: var(--mantine-color-brand-6);
}
